import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportCommissionByFinancial } from './CommissionByFinancial.services';

export function useQuestReportCommissionByFinancial() {
  return useMutation(getQuestReportCommissionByFinancial, {
    onSuccess() {
      notification.success({
        message:
          'O relatório de comissão por financeiro foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
